




































import {Vue, Component, Prop} from 'vue-property-decorator'
import Utils from '@/utils'
import {EventBus} from '@/main'
import {Action, State} from 'vuex-class'
import {DialogState} from '@/store'
import {ClientTypeState} from '@/store/modules/clientTypes'
import {
  AppConfig,
  Driver,
  Attachment,
  RegistrationImage,
} from '@/lib/kepler/interfaces'
import {CameraHelper} from '@/lib/CameraHelper'
import {AppConfigState} from '@/store/modules/configuration'

import {ValidationProvider} from 'vee-validate'
import {VTextField} from 'vuetify/lib'
import UpdateProfileImageDialog from '@/components/profile/UpdateProfileImageDialog.vue'
import Axios from 'axios'

@Component({
  components: {
    ValidationProvider,
    VTextField,
    Btn: Utils.loadComponent('proxy/Btn'),
    Button: Utils.loadComponent('Button'),
    Img: Utils.loadComponent('proxy/Image'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Card: Utils.loadComponent('proxy/Card/Card'),
    CustomIcon: Utils.loadComponent('CustomIcon'),
  },
  name: 'SelfieRegistrationView',
})
export default class SelfieRegistrationView extends Vue {
  @State('clientTypes') public types!: ClientTypeState
  @State('configuration') public configState!: AppConfigState
  @State('registration') public registrationState!: { [k: string]: any }
  @State((state) => state.configuration.appConfig) public appConfig!: AppConfig
  @State((state) => state.profile.language) public profileLang!: string

  @Action('openDialog') public openDialog: any
  @Action('closeDialog') public closeDialog: any

  @Action('addProfilePicture') public addProfilePicture!: ({}) => Promise<Driver>

  @Prop() public readonly rules!: string
  @Prop() public readonly label!: string
  @Prop({type: Boolean, default: false}) public readonly required!: boolean
  @Prop({type: Object}) public readonly value!: RegistrationImage

  protected get isBrowser() {
    return device.platform === 'browser'
  }

  public loading: boolean = false
  protected browserCameraIsOpen: boolean = false
  protected cannotLoadImage = false

  protected imageUploadResponse = this.value ? this.value : new RegistrationImage()

  protected cameraOptions: CameraOptions = {
    allowEdit: true,
    cameraDirection: 1,
    correctOrientation: true,
    destinationType: 1,
    encodingType: 0,
    mediaType: 0,
    quality: 50,
    saveToPhotoAlbum: false,
    sourceType: 1,
    targetHeight: 512,
    targetWidth: 512,
  }

  protected camera: CameraHelper | null = null

  protected browserCameraRatio: number = 0

  protected selfieButtonColor: string = 'accent'

  protected initCamera(fallback?: boolean) {
    this.cameraOptions.sourceType = fallback ? 0 : 1

    return new CameraHelper(
      `${this.$env.API_URL}v1/attachment/upload`, this.cameraOptions, true, (response: Attachment) => {
        this.imageUploadResponse.token = response.token
        this.imageUploadResponse.url = response.url
        const r = {...response, height: this.camera!.height, width: this.camera!.width}
        this.$emit('input', r)
      })
  }

  protected get uploaded() {
    return !!(this.imageUploadResponse && this.imageUploadResponse.token && this.imageUploadResponse.url)
  }

  protected getSelfie() {
    if (this.camera) {
      if (this.isBrowser) {
        EventBus.$on('cameraError', () => {
          this.openDialog(new DialogState(UpdateProfileImageDialog, {
            cancelCallback: () => {
              return null
            },
            uploadCallback: (response: Attachment) => {
              this.imageUploadResponse.token = response.token
              this.imageUploadResponse.url = response.url
              this.camera!.Url = response.url
              this.$emit('input', response)
            },
          }))
        })
        const browsercameraLaunched = () => {
          this.$nextTick(() => {
            this.browserCameraIsOpen = true
            const cam = this.$refs.selfieBoxCamera
            if (this.$refs && cam) {
              const el = (cam as Vue).$el
              this.browserCameraRatio = el.clientWidth / el.clientHeight
            }
            EventBus.$off('browserCameraLaunched', browsercameraLaunched)
          })
        }
        EventBus.$on('browserCameraLaunched', browsercameraLaunched)
        EventBus.$on('gotPhoto', () => {
          this.browserCameraIsOpen = false
        })
      } else {
        EventBus.$on('cameraError', () => {
          this.camera = this.initCamera(true)
          this.camera.init()
          EventBus.$off('cameraError')
        })
      }
      this.camera.init()
    }
  }

  protected resetCamera() {
    const empty: RegistrationImage = {token: '', mime: '', url: '', width: 512, height: 512}
    this.$emit('input', empty)
    this.imageUploadResponse = empty
    this.cannotLoadImage = false
    this.camera = this.initCamera()
  }

  protected retakePicture(camera: CameraHelper) {
    this.resetCamera()
    this.getSelfie()
  }

  // flow stuff

  protected mounted() {
    this.camera = this.initCamera()
    if (this.value && this.value.token && this.value.url) {
      const camera = this.camera
      let err: string | number = ''
      const setDimensionsAndUrl = () => {
        camera.manuallySetUrl(this.value.url)
        camera.setDimensions(this.imageUploadResponse.width, this.imageUploadResponse.height)
      }
      Axios.get(this.value.url)
        .then(setDimensionsAndUrl)
        .catch((e: any) => {
          err = e.response.status
          camera.manuallySetUrl('')
          this.cannotLoadImage = true
        })
    }
  }

  protected beforeDestroy() {
    if (this.camera) {
      this.camera.cleanUp()
    }
    EventBus.$off('cameraError')
    EventBus.$off('gotPhoto')
    EventBus.$off('browserCameraLaunched')
  }

  // this is the last step
  protected get validateSelfie() {
    if (this.camera) {
      return !!(this.camera.Url) || !this.required
    }
  }

  protected validated() {
    const form = (this.$refs.quickRegistration as any)
    if (form) {
      return this.validateSelfie
    }
    return false
  }

  protected uploadPicture(camera: CameraHelper) {
    if (!this.imageUploadResponse.token) {
      this.loading = true
      return new Promise((resolve: () => void) => {
        camera.uploadPicture()
          .then((r) => {
            EventBus.$on('loginByPhone', () => {
              this.addProfilePicture({attachment_token: r.token}).then(() => {
                EventBus.$off('loginByPhone')
              })
            })
            resolve()
          })
          .catch(() => {
            if (!this.required) {
              resolve()
            } else {
              this.selfieButtonColor = 'error'
            }
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
